var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbsenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5605",
    "data-name": "Group 5605",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.905,
    height: 52.905,
    viewBox: "0 0 52.905 52.905",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5604",
    "data-name": "Group 5604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8238",
    "data-name": "Path 8238",
    d: "M22.781,19.067a9.128,9.128,0,0,0,.846-3.809A9.268,9.268,0,0,0,14.369,6a9.128,9.128,0,0,0-3.809.846Z",
    transform: "translate(12.083 4.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8239",
    "data-name": "Path 8239",
    d: "M28.452,2A26.452,26.452,0,1,0,54.9,28.452,26.462,26.462,0,0,0,28.452,2Zm0,34.388A26.311,26.311,0,0,0,12.211,42a21.064,21.064,0,0,1-.45-26.505l7.565,7.565a9.178,9.178,0,0,0,7.909,7.909l5.82,5.82A26.586,26.586,0,0,0,28.452,36.388Zm16.691,5.026L15.491,11.761A20.9,20.9,0,0,1,28.452,7.29,21.127,21.127,0,0,1,45.144,41.414Z",
    transform: "translate(-2 -2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsenceIcon);
export default __webpack_public_path__ + "static/media/absence_icon.c652562fe818455ef2e45715f08738bd.svg";
export { ForwardRef as ReactComponent };